import { render, staticRenderFns } from "./LeadsHandlersAccessPage.vue?vue&type=template&id=48d73bdf&scoped=true&"
import script from "./LeadsHandlersAccessPage.vue?vue&type=script&lang=js&"
export * from "./LeadsHandlersAccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d73bdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d73bdf')) {
      api.createRecord('48d73bdf', component.options)
    } else {
      api.reload('48d73bdf', component.options)
    }
    module.hot.accept("./LeadsHandlersAccessPage.vue?vue&type=template&id=48d73bdf&scoped=true&", function () {
      api.rerender('48d73bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LeadsHandlersAccessPage.vue"
export default component.exports